import React from 'react';
import css from './form-control.module.scss';
import { FormControl as FormControlBase } from '@mui/base/FormControl';
import clsx from 'clsx';

type Props = React.ComponentProps<typeof FormControlBase> & {
  as?: React.ComponentType;
  size?: 'xs' | 'small' | 'default' | 'nested';
};

const FormControl = ({ children, as, size, ...props }: Props) => {
  const Component = as || FormControlBase;

  return (
    <Component
      {...props}
      className={clsx(css.root, size && css[`size-${size}`])}
    >
      {children}
    </Component>
  );
};

export default FormControl;
